import { IconButton, Tooltip } from '@material-ui/core';
import Edit from '@material-ui/icons/Edit';
import { PropsWithChildren } from 'react';
import { BaseDialog } from './BaseDialog';
import { Account, Features } from './types';

export interface BaseEditIconProps {
  workloadData: Account | undefined;
  requesterEmail: string;
  handleClickOpen: any;
  isModalOpen: boolean;
  handleClose: any;
  handleConfirm: any;
  disableConfirm: boolean;
  apiValidationPayload: any;
  features?: Features;
  isLoading: boolean;
  isLoadingEdit: boolean;
  dialogTitle: string;
  allowOwnerEdit?: boolean;
  allowEngineerEdit?: boolean;
}

export function BaseEditIcon(props: PropsWithChildren<BaseEditIconProps>) {
  let title = '';
  if (props.isLoadingEdit) {
    title += 'Loading...';
  } else {
    title = 'Update available for ';
    if (props.allowOwnerEdit) {
      title += `account owners`;
    }
    if (props.allowOwnerEdit && props.allowEngineerEdit) {
      title += ' and';
    }
    if (props.allowEngineerEdit) {
      title += ` ${props.workloadData?.pdpEditEntitlement} group members`;
    }
  }

  function allowEditAccess(): boolean {
    if (props.allowOwnerEdit) {
      if (
        props.workloadData?.ownerMembers
          ?.filter(member => member !== null)
          ?.map(member => member.toLowerCase())
          .includes(props.requesterEmail.toLowerCase())
      ) {
        return true;
      }
    }
    if (props.allowEngineerEdit) {
      if (
        props.workloadData?.engineerMembers
          ?.filter(member => member !== null)
          ?.map(member => member.toLowerCase())
          .includes(props.requesterEmail.toLowerCase())
      ) {
        return true;
      }
    }
    return false;
  }

  return (
    <>
      <Tooltip title={title}>
        <span>
          <IconButton
            onClick={props.handleClickOpen}
            disabled={props.isLoadingEdit || !allowEditAccess()}
          >
            <Edit />
          </IconButton>
        </span>
      </Tooltip>
      <BaseDialog
        open={props.isModalOpen}
        handleClose={props.handleClose}
        handleConfirm={props.handleConfirm}
        disableConfirm={props.disableConfirm}
        title={props.dialogTitle}
        isLoading={props.isLoading}
      >
        {props.children}
      </BaseDialog>
    </>
  );
}
